LS.support = {
	/**
	 * Initialize browser feature detection
	 */
	check() {
		$.supported('touch', {
			callback: () => {
				document.documentElement.classList.remove('-c');
				document.documentElement.classList.add('-t');
			}
		});
	}
};